<style lang="less">
    .click-text {
        position: relative;
        width: auto;
        height: 30px;
        // border: 1px solid #dadada;
        // border-radius: 3px;
        padding: 5px;
        outline: none;
        .edit-span {
            display: block;
            line-height: 18px;
            width: 100%;
            height: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            user-select: none;
            cursor: pointer;
            &::selection {
                background: rgba(1, 127, 255, 0.15);
                color: var(--text-color-primary);
            }
        }
        .item-icon {
            width: 30px;
        }
        .hide-text {
            visibility: hidden;
        }
        .edit-input {
            width: 100%;
            height: 22px;
            position: absolute;
            left: 0;
            top: 4px;
            text-indent: 5px;
            text-overflow: ellipsis;
            overflow: hidden;
            background: var(--bg-color-primary);
            color: var(--text-color-primary);
            border: none;
            border-bottom: 1px solid var(--bg-color-top-lock-line);
            border-radius: 3px;
            &::selection {
                background: rgba(1, 127, 255, 0.15);
                color: var(--text-color-primary);
            }
        }
        .input-tips {
            display: none;
            position: absolute;
            width: 100%;
            bottom: 35px;
            left: 0;
            padding: 5px 10px;
            box-shadow: 0 0 9px #d9d9d9;
            word-break: break-word;
            background-color: #fff;
        }
        .input-tips.showTips {
            display: block;
            animation: show 0.6s linear forwards;
        }
        .input-tips.closeTips {
            display: block;
            animation: close 0.3s linear forwards;
        }
    }
    @keyframes show {
        0% {
            opacity: 0;
        }
        40% {
            opacity: 0.7;
        }
        100% {
            opacity: 1;
        }
    }
    @keyframes close {
        0% {
            opacity: 1;
        }
        40% {
            opacity: 0.3;
        }

        80% {
            opacity: 0.1;
        }
        100% {
            display: none;
            opacity: 0;
        }
    }
</style>

<template>
    <div ref="renameBox" class="click-text" @mouseover="openTips()" @mouseleave="closeTips()">
        <span class="edit-span" :class="{ 'hide-text': globalEditing }" v-on:[eventName]="startEdit()">{{ editText }}</span>
        <input
            ref="renameInput"
            @blur="editOver"
            class="edit-input"
            v-show="globalEditing"
            v-model="editText"
            type="text"
            maxlength="32"
            @keyup.esc="keyboard('enter')"
            @keypress.enter="keyboard('enter')"
        />
        <div
            class="input-tips"
            :class="{ showTips: active && showTips && editText.length > 0, closeTips: active && !showTips }"
            v-text="editText"
        ></div>
        <!-- <div class="edit-icon"><iconSymbol class="item-icon" name="edit-doc" /></div> -->
    </div>
</template>

<script lang="ts">
    import { Component, Watch, Prop, Vue } from "vue-property-decorator";

    @Component({})
    export default class MyComponent extends Vue {
        @Prop(String)
        text!: string;
        @Prop(Number)
        index!: number;
        @Prop({ default: "dblclick" }) eventName!: string;

        timer: number = 0; // 防止多次触发
        globalEditing: boolean = false; // 是否进入编辑状态
        editText: string = "";
        active: boolean = false; // 是否激活tips
        showTips: boolean = false; // 是否显示tips

        startEdit() {
            window["_view"]._tool.endEdit();
            this.globalEditing = true;
            this.$nextTick(() => {
                (this.$refs.renameInput as HTMLElement).focus();
                (this.$refs.renameInput as HTMLInputElement).select();
            });
        }
        editOver() {
            // 编辑完成
            this.globalEditing = false;
            this.$store.commit("setStatus", {
                type: "editingIndex",
                data: null,
            });
            if (!this.editText || this.editText == this.text) {
                this.editText = this.text;
                return;
            }
            if (this.index !== void 0) {
                console.log(this.index);
                this.$emit("editOK", this.editText, this.index);
            } else {
                this.$emit("editOK", this.editText);
            }
        }

        renameFail(name, type) {
            if (type == "isSameName") {
                this.globalEditing = true;
                this.$nextTick(() => {
                    (this.$refs.renameInput as HTMLElement).focus();
                    (this.$refs.renameInput as HTMLInputElement).select();
                });
            }
            this.editText = name;
        }
        // closeBox(e){ // 点击空白处关闭输入框
        //     let objTarget = this.$refs.renameBox as HTMLElement;
        //     if(objTarget != e.target && !objTarget.contains(e.target) ){
        //         this.editOver()
        //     }
        // }
        keyboard(type) {
            if (type == "enter") {
                (this.$refs.renameInput as HTMLElement).blur();
            }
        }
        openTips() {
            // 进入展开提示框
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.showTips = true;
                this.active = true;
            }, 600);
        }
        closeTips() {
            // 离开关闭提示框
            if (this.timer) clearTimeout(this.timer);
            this.showTips = false;
            this.timer = setTimeout(() => {
                this.active = false;
            }, 300);
        }

        get editingIndex() {
            return this.$store.state.ui.editingIndex;
        }

        @Watch("editingIndex")
        OnEditingChange() {
            if (this.index !== void 0 && this.index == this.editingIndex) {
                this.startEdit();
            }
        }
        @Watch("text")
        OnChangeTextChange() {
            this.editText = this.text;
        }

        mounted() {
            this.editText = this.text;
        }

        created() {}
    }
</script>
